import { Copy } from "lucide-react";
import { toast } from "sonner";
import { fileSize } from "@/lib/format";
import { AlbumChips } from "./GuestAlbumPicker";
import { birthdayLabel } from "./PeopleTab";
import { Actions } from "./UsersTab";
import { DeleteAccountButton } from "./DeleteAccount";

const copy = async (text, what) => {
  try { await navigator.clipboard.writeText(text); toast.success(`${what} copied`); } catch { window.prompt(`Copy this ${what.toLowerCase()}`, text); }
};

const badgeOf = ({ user: u, person: p }) => {
  if (u?.blocked) return "blocked";
  if (u && !u.email_verified) return "unverified";
  if (u) return u.role;
  return p?.guest?.status === "active" ? "guest" : "no login";
};

const Btn = ({ onClick, testid, children }) => <button className="btn-outline !py-1 !px-3 text-xs inline-flex gap-1 items-center" onClick={onClick} data-testid={testid}>{children}</button>;

const PersonButtons = ({ row, ops }) => {
  const p = row.person;
  const g = p?.guest?.status === "active" ? p.guest : null;
  if (!p) return <Btn onClick={() => ops.edit(row)} testid={`member-add-birthday-${row.key}`}>Add birthday</Btn>;
  return (
    <>
      <Btn onClick={() => ops.edit(row)} testid={`person-edit-${p.id}`}>Edit birthday / nicknames</Btn>
      {!row.user && (
        <>
          {g && <Btn onClick={() => copy(g.username, "Username")} testid={`person-copy-username-${p.id}`}><Copy size={12} />Username</Btn>}
          {g && <Btn onClick={() => copy(`${window.location.origin}${g.url_path}`, "Link")} testid={`person-copy-link-${p.id}`}><Copy size={12} />Link</Btn>}
          {g && p.email && <Btn onClick={() => ops.person("email", p)} testid={`person-email-link-${p.id}`}>Email link</Btn>}
          <Btn onClick={() => ops.person("grant", p)} testid={`person-grant-${p.id}`}>{g ? "Re-grant 7 days" : "Give guest access"}</Btn>
          {g && <Btn onClick={() => ops.person("revoke", p)} testid={`person-revoke-${p.id}`}>Revoke</Btn>}
        </>
      )}
      <Btn onClick={() => ops.person("remove", p)} testid={`person-delete-${p.id}`}>Remove person</Btn>
    </>
  );
};

export const MemberRow = ({ row, me, ops }) => {
  const { user: u, person: p } = row;
  const badge = badgeOf(row);
  const g = p?.guest;
  return (
    <div className="admin-row" data-testid={`member-row-${row.key}`}>
      <div className="min-w-0">
        <div className="text-sm text-neutral-900 truncate">
          {u?.name || p?.name}{p?.nicknames?.length > 0 && <span className="text-neutral-500"> · {p.nicknames.join(", ")}</span>}
          {" "}<span className={`role-chip role-${badge.replace(" ", "-")}`} data-testid={`member-badge-${row.key}`}>{badge}</span>
        </div>
        <div className="text-xs text-neutral-500 mt-0.5">
          {[u?.email || p?.email, p?.month && `Birthday ${birthdayLabel(p)}`, u && `${u.photo_count} photos`, u?.private_count && `Private library: ${u.private_count} items, ${fileSize(u.private_bytes)} (owner-only)`].filter(Boolean).join(" · ") || "No email or birthday"}
        </div>
        {g && (
          <div className="mt-1 inline-flex flex-wrap gap-1.5 items-center">
            <span className={`role-chip role-${g.status}`} data-testid={`person-guest-status-${p.id}`}>{g.status === "active" ? `guest · ${g.days_left} day${g.days_left === 1 ? "" : "s"} left` : g.status}</span>
            <span className="text-xs text-neutral-700" data-testid={`person-guest-username-${p.id}`}>@{g.username}</span>
            <AlbumChips link={g} />
          </div>
        )}
      </div>
      <div className="flex flex-wrap gap-2 justify-end">
        {u && u.user_id !== me.user_id && <><Actions u={u} onPatch={ops.patchUser} onReset={ops.sendReset} /><DeleteAccountButton u={u} /></>}
        <PersonButtons row={row} ops={ops} />
      </div>
    </div>
  );
};
